﻿(function () {
    'use strict';

    var serviceId = 'repository.security';

    angular
        .module('app.services')
        .factory(serviceId, security);

    security.$inject = ['common', 'repository.abstract'];

    function security(common, abstractRepository) {
        var config = common.config;
        function Ctor(mgr) {
            this.manager = mgr;

            this.getUserInfo = getUserInfo;
            this.getLanguagesByCulture = getLanguagesByCulture;
            this.getUserByName = getUserByName;
            this.getToolbar = getToolbar;
            this.getBusinessPartnerUserRoles = getBusinessPartnerUserRoles;
            this.getLogin = getLogin;
            this.changePassword = changePassword;
            this.getMenuBar = getMenuBar;
            this.getRoleByUser = getRoleByUser;
            this.getTest = getTest;

            this.getUserInformation = getUserInformation;
            this.getPortalAlerts = getPortalAlerts;
        }
        abstractRepository.extend(Ctor);

        return Ctor;

        function getUserInfo(userLogin) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'security/GetUserInfo', userLogin);
        }

        function getLanguagesByCulture(culture) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'security/GetLanguagesByCulture/' + culture);
        }

        function getUserByName(userName, password, languageId) {
            var model = { Username: userName, Password: password, LanguageId: languageId };
            return common.httpPost(config.basePaths.Base_Path_Resources + 'security/GetUserByInformationComplete/', model);
        }

        function changePassword(userId, currentPassword, newPassword) {
            var model = { UserId: userId, CurrentPassword: currentPassword, NewPassword: newPassword }
            return common.httpPost(config.basePaths.Base_Path_Resources + 'security/ChangePassword/', model);
        }

        function getMenuBar() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'security/GetMenuBar');
        }

        function getToolbar(pageName) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'security/GetToolbar/' + replaceQuotes(pageName));
        }

        function getBusinessPartnerUserRoles(userName) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetBusinessPartnerUserRoles?userName=' + userName);
        }

        function getLogin(userName, password) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'security/Login/' + userName + "/" + password);
        }

        function getRoleByUser() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'security/GetRoleByUser');
        }

        function replaceQuotes(text) {
            return text.replace(/["']/g, "");
        }

        function getTest() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'security/Test');
        }

        //=====================================
        //INICIO: http resquest to internal services
        //=====================================
        function getUserInformation() {
            var uri = `${config.basePaths.Base_Path_Resources}account/getUser?applicationCode=${config.applicationCode}&organizationCode=${config.organizationCode}`;
            return common.httpGet(uri);
        }
        //=====================================
        //FIN: http resquest to internal services
        //=====================================
        function getPortalAlerts(yardCode) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'alertSetting/GetPortalAlerts?yardCode=' + yardCode);
          }
    }
})();